import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.number.constructor.js";
/**
 * getLocalAndParentRank
 * @param {string} rank - The rank of the content
 * @returns {object} {
 * rankInSection: number that can be used for in-section sorting,
 * parentRank: string | null which is equivalent to the rank of the parent
 * }
 */
export function getLocalAndParentRank(rank) {
  var lastSeparatorIndex = rank.lastIndexOf('.');
  var hasParent = lastSeparatorIndex !== -1;
  if (!hasParent) {
    return {
      rankInSection: Number(rank),
      parentRank: null
    };
  }
  var rankInSection = Number(rank.slice(lastSeparatorIndex + 1));
  var parentRank = rank.slice(0, lastSeparatorIndex);
  return {
    rankInSection: rankInSection,
    parentRank: parentRank || null
  };
}